import React from 'react';
import { FormatComponentProps } from './types';

const BracketText: React.FC<FormatComponentProps> = ({ content }) => {
  const bracketText = content.replace(/^\[|\]$/g, '');
  return <span style={{ fontWeight: 600 }}>{bracketText}</span>;
};

export default BracketText;
